import type { FC } from 'react';
import React from 'react';

import NoSale from 'Components/VehicleList/NoSale/NoSale';
import NotFoundFilters from 'Components/VehicleList/NotFoundFilters/NotFoundFilters';
import { useHasFilters } from 'Components/VehicleList/VehicleListV2/FilterBarV2/hooks/useHasFilters';
import useShouldFetchVehicles from 'Utilities/hooks/vehicleList/useShouldFetchVehicles';

interface VehicleListEmptyStateV2Props {
	filteredVehicleCount: number;
	isLoading?: boolean;
	vehicleCount: number;
}

export const VehicleListEmptyStateV2: FC<VehicleListEmptyStateV2Props> = ({
	filteredVehicleCount,
	isLoading,
	vehicleCount,
}) => {
	const shouldFetchVehicles = useShouldFetchVehicles();
	const hasActiveFilters = useHasFilters();

	if (!shouldFetchVehicles) {
		return <NoSale />;
	}

	if (isLoading) {
		return null;
	}

	const noVehiclesFound = filteredVehicleCount === 0 || vehicleCount === 0;

	if (noVehiclesFound && hasActiveFilters) {
		return <NotFoundFilters />;
	}

	if (noVehiclesFound && !hasActiveFilters) {
		return <NoSale />;
	}

	return null;
};
